import AppPaths from '../../all/AppPaths'
import { pick } from 'lodash'
export default pick(
  AppPaths,
  'login',
  'home',
  'profile',
  'changePassword',
  'user',
  'model',
  'reference',
  'supplier',
  'center',
  'order',
  'centergroup',
  'campaign',
  'request',
  'stock',
  'arrivals',
  'providerEntity',
  'comparator',
  'delivery',
  'category',
  'tax',
  'expedientTypes',
  'executionPlans',
  'inventory',
  'brand'
)